<template>
  <div id="agent_login">
    <van-row>
      <van-col span="24" class="agent_login_title">
        <div class="agent_login_title_position">{{ $t('agent.agent_platform') }}</div>
      </van-col>
      <van-col span="21" offset="1">
        <van-form @submit="onSubmit">
          <van-field
            v-model="username"
            :label="$t('agent.account')"
            :placeholder="$t('agent.enter_account')"
            class="agent_login_border"
          />
          <van-field
            v-model="password"
            type="password"
            :label="$t('agent.password')"
            :placeholder="$t('agent.enter_password')"
            class="agent_login_border"
          />
          <div class="agent_login_button">
            <van-button round block color="linear-gradient(#fa793e, #f96624)" native-type="submit">{{ $t('agent.submit') }}</van-button>
          </div>
        </van-form>
      </van-col>
    </van-row>

  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import mongolian from "../assets/lang/mongolian";
export default {
  data() {
    return {
      username: '',
      password: '',
    }
  },
  created: function() {
    document.title = this.$t('agent.agent_platform')
  },
  methods: {
    onSubmit() {
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent_admin&act=login", {
        params: {
          username: this.username,
          password: this.password,
          is_login: 1
        }
      }).then(res => {
        console.log(res.data)
        if (res.data.status === 1) {
          // 存入缓存
          localStorage.setItem('agentAdminToken', res.data.data.token)
          localStorage.setItem('agentAdminLevel', res.data.data.platform_level)
          localStorage.setItem('is_agent_authority', res.data.data.is_agent_authority)
          this.jump_href()
        } else {
          Toast(res.data.error)
        }

      })
    },
    jump_href() {
      this.$router.push({ path: '/agent_admin' });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agent_login.vue